import { render, staticRenderFns } from "./TeacherList.vue?vue&type=template&id=f0e57046&scoped=true&"
import script from "./TeacherList.vue?vue&type=script&lang=ts&"
export * from "./TeacherList.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherList.vue?vue&type=style&index=0&id=f0e57046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e57046",
  null
  
)

export default component.exports